import { Plus } from "lucide-react";
import { ModalTrigger } from "./ModalTrigger";

interface NewUserTriggerProps {
  accountId?: string;
}

export const NewUserTrigger = ({ accountId }: NewUserTriggerProps) => {
  return (
    <ModalTrigger
      modalPath="/modals/user/create"
      modalState={{ accountId }}
      className="cursor-pointer bg-lime text-foreground hover:text-background w-32 h-8 flex mx-auto"
    >
      <Plus className="w-4 h-4" />
      New User
    </ModalTrigger>
  );
};
